// extracted by mini-css-extract-plugin
export default {"headerDiv":"MessageSent_headerDiv__K8mVk","MessageSent":"MessageSent_MessageSent__W9Qye","body":"MessageSent_body__0y-Rz"};